import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Breadcrumb from '../components/ui/Breadcrumb';
import StatisticsView from '../components/statistics/StatisticsView';
import LoadingBall from '../components/loading/LoadingBall';
import { fetchComplexById } from '../api/complexes';
import { getFields } from '../api/fields';
import { Complex, Field } from '../types';
import { COMMON_TRANSLATE_KEYS } from '../constants/translate-keys';

const FIELDS_LIMIT = 100;

const ComplexStatistics = () => {
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [complex, setComplex] = useState<Complex | null>(null);
  const [fields, setFields] = useState<Field[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const complexId = Number(id);

      const [complexResult, fieldsResult] = await Promise.all([
        fetchComplexById(complexId),
        getFields(complexId, 1, FIELDS_LIMIT),
      ]);

      if (complexResult.data) {
        setComplex(complexResult.data);
      }

      if (fieldsResult.data) {
        setFields(fieldsResult.data.fields);
      }
    };

    fetchData();
  }, [id]);

  if (!complex) {
    return <LoadingBall className="w-full h-screen" />;
  }

  return (
    <div className="mx-[30px] mb-10">
      <Breadcrumb
        className="sm:mb-8 mb-10"
        links={[
          {
            name: t(COMMON_TRANSLATE_KEYS.COMPLEXES),
            to: '/my-fields',
          },
          {
            name: `${complex.name} (${t(COMMON_TRANSLATE_KEYS.COMPLEX)})`,
            to: `/arena/${complex.id}/info`,
          },
        ]}
      >
        {t(COMMON_TRANSLATE_KEYS.STATISTICS)}
      </Breadcrumb>
      <StatisticsView
        complexId={complex.id}
        complexName={complex.name}
        fields={fields}
        openingHours={complex.openingHours}
        closingHours={complex.closingHours}
      />
    </div>
  );
};

export default ComplexStatistics;
